module.exports = __webpack_public_path__ + "static/img/brid_details.4a81e81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/brid_details.png
// module id = 9u7e
// module chunks = 1 3